import { Injectable } from '@angular/core';
import { SeleccionService } from '../servicios/seleccion.service';
import { IngresoService } from '../servicios/ingreso.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class recursosCompartido {

    constructor(private srvSelect: SeleccionService, private srvInsert: IngresoService, private sanitizer: DomSanitizer) { }

    //OBTENER EL TOKEN VIGENTE EN CASO DE HABER EN LA BASE DE DATOS
    async getTokenLocal() {
        let valToken: any;
        const resToken = await new Promise<any>(resolve => this.srvSelect.gestionOtros(3, 'na').subscribe(translated => { resolve(translated) }));
        if (resToken.success == true)
            valToken = resToken.ajustes[0]['strToken'];
        else
            valToken = this.getTokenCargaDrive();
        return valToken;
    }
    //GENERAR UN NUEVO TOKEN Y GUARDAR EN LA BASE DE DATOS
    async getTokenCargaDrive() {
        let token = '';
        const resGetToken = await new Promise<any>(resolve => this.srvSelect.postTokenPDF().subscribe(translated => { resolve(translated) }));
        if (resGetToken.success) {
            this.srvInsert.ingresoGestionPostulante(resGetToken.token, resGetToken.created, resGetToken.exp,
                localStorage.getItem('ciUsuario'), 'becario', localStorage.getItem('localCarrera'), 'na', 'na', 5).subscribe(res => {
                    if (res.postula)
                        token = resGetToken.token;
                });
        }
        return token;
    }
    //OBTENER EL ARCHIVO PDF
    async obtenerArchivoPDF(tokenPDF, rutaPDF) {
        let rutaGetPDF: any;
        const resPDF = await new Promise<any>(resolve => this.srvInsert.mostrarArchivo(tokenPDF, rutaPDF).subscribe(translated => { resolve(translated) }));
        rutaGetPDF = this.construirPDF(resPDF.download);
        return rutaGetPDF;
    }
    //OBTENER LA RUTA DEL ARCHIVO PDF
    async obtenerRutaPDF(tokenPDF, rutaPDF) {
        let rutaGetPDF: any;
        const resPDF = await new Promise<any>(resolve => this.srvInsert.mostrarArchivo(tokenPDF, rutaPDF).subscribe(translated => { resolve(translated) }));
        rutaGetPDF = resPDF.download;
        return rutaGetPDF;
    }
    //OBTENER EL 64 COMPLETO Y SANITIZAR
    async construirPDF(ruta: any) {
        let rutaArchivo: any;
        let rutaLocal: any = await this.toDataURL(ruta);
        rutaArchivo = await this.bypassAndSanitize(rutaLocal);
        return (rutaArchivo);
    }
    //SANITIZA EL BASE 64
    bypassAndSanitize(url: any): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    //CONVERTIR UNA URL EN BASE 64
    toDataURL = async (url: any) => {
        var res = await fetch(url);
        var blob = await res.blob();
        const result = await new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.addEventListener("load", function () {
                resolve(reader.result);
            }, false);
            reader.onerror = () => {
                return reject(this);
            };
            reader.readAsDataURL(blob);
        })
        return result
    };
    //TRANSFORMAR EL 64 EN BLOB
    dataURItoBlob(base64: any, fileName: string): File {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; ++i) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const blobData = new Blob([bytes], { type: 'application/pdf' });
        return new File([blobData], fileName, { type: 'application/pdf' });
    };


    //OBTENER TODA LA INFORMACION DE UN ESTUDIANTE EL PERIODO ACADEMICO
    async verDataMatricula(carrera, periodo, cedula) {
        let cont: number = 0; let banCarrera = false; let antPeriodo; let antPromedio; let antNumMat; let actNumMat;
        let auxMatricula = []; let vecMatricula: Array<any> = [];
        //OBTENER LAS INSCRIPCIONES DEL ESTUDIANTE
        const resInsc = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(1, 'na', cedula, 'na', 'na').subscribe(translated => {
            resolve(translated)
        }));
        if (resInsc.success) {
            while (cont < resInsc.matricula.length && !banCarrera) {
                //PREGUNTAMOS SI TIENE MATRÍCULA VIGENTE A LA FECHA ACTUAL
                const resMatr = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(3, resInsc.matricula[cont]['baseCarrera'], cedula, 'na', 'na').subscribe(translated => {
                    resolve(translated)
                }));
                if (resMatr.success) {
                    banCarrera = true;
                    antPeriodo = await this.verPeriodoAnteriosr(periodo);
                    antPromedio = await this.verPromedioEstudiante(resInsc.matricula[cont].baseCarrera, antPeriodo, resMatr.matricula[0].codEstudiante);
                    antNumMat = await this.verTotalNumMatricula(resInsc.matricula[cont].baseCarrera, antPeriodo, cedula);
                    actNumMat = await this.verTotalNumMatricula(resInsc.matricula[cont].baseCarrera, periodo, cedula);
                    auxMatricula.push({
                        'baseCarrera': resInsc.matricula[cont].baseCarrera, 'nombFacultad': resInsc.matricula[cont].nombFacultad,
                        'nombCarrera': resInsc.matricula[cont].nombCarrera, 'nombSede': resInsc.matricula[cont].strSede,
                        'fechaNac': resMatr.matricula[0].dtFechaNac.split('T')[0], 'codNivel': resMatr.matricula[0].strCodNivel,
                        'codCarrera': resInsc.matricula[cont].strCodCarrera, 'codFacultad': resInsc.matricula[cont].codFacultad,
                        'codPeriodo': resMatr.matricula[0].strCodPeriodo, 'codEstudiante': resMatr.matricula[0].codEstudiante, cedEstudiante: cedula,
                        'sexoEstudiante': resMatr.matricula[0].strCodSexo, 'nombEstudiante': resMatr.matricula[0].strNombres, 'apelEstudiante': resMatr.matricula[0].strApellidos
                    })
                }
                cont++;
            }
        }
        vecMatricula.push({ banMatricula: banCarrera, matricula: auxMatricula, promedioAnterior: antPromedio, matriculaActual: actNumMat, matriculaAnterior: antNumMat });
        return (vecMatricula);
    }
    //FUNCION QUE OBTIENE EL PERIODO VIGENTE A LA FECHA ACTUAL
    async verPeriodoVigente() {
        let vecPeriodo = [];
        //OBTENER LOS PERIODOS ACADEMICOS DE LA MASTER
        const resPeriodo = await new Promise<any>(resolve =>
            this.srvSelect.gestionCarreras(10, 'na', 'na', 'na').subscribe(translated => {
                resolve(translated)
            }));
        if (resPeriodo.success)
            vecPeriodo.push({ estado: true, periodo: resPeriodo.carrera })
        else
            vecPeriodo.push({ estado: false, periodo: '' });
        return (vecPeriodo);
    }
    //FUNCION QUE DEVUELVE EL PERIODO ANTERIOR AL ENVIADO POR PARAMETRO
    async verPeriodoAnteriosr(codPeriodo) {
        let PosPeriodo = 0; let getPeriodo = 0;
        //OBTENER LOS PERIODOS ACADEMICOS DE LA MASTER
        const resPeriodo = await new Promise<any>(resolve =>
            this.srvSelect.gestionCarreras(3, 'na', 'na', 'na').subscribe(translated => {
                resolve(translated)
            }));
        if (resPeriodo.success) {
            PosPeriodo = resPeriodo.carrera.findIndex(item => item.strCodigo == codPeriodo) >= 0 ? (resPeriodo.carrera.findIndex(item => item.strCodigo == codPeriodo) + 1) : -1;
            getPeriodo = resPeriodo.carrera[PosPeriodo].strCodigo;
        }
        return (getPeriodo);
    }
    //FUNCION QUE DEVUELVE UN PERIODO ACADÉMICO DADO LA POSICION
    async verPeriodoPosicion(numPos) {
        let getPeriodo = 0;
        //OBTENER LOS PERIODOS ACADEMICOS DE LA MASTER
        const resPeriodo = await new Promise<any>(resolve =>
            this.srvSelect.gestionCarreras(3, 'na', 'na', 'na').subscribe(translated => {
                resolve(translated)
            }));
        if (resPeriodo.success)
            getPeriodo = resPeriodo.carrera[numPos].strCodigo;
        return (getPeriodo);
    }
    //FUNCION QUE MUESTRA EL PROMEDIO DE UN ESTUDIANTES DADO EL PERÍODO
    async verPromedioEstudiante(baseCarrera, codPeriodo, codEstudiante) {
        let getPromedio = 0;
        //OBTENER EL PROMEDIO EN BASE AL PERÍODO ANTERIOR
        const resPromedio = await new Promise<any>(resolve =>
            this.srvSelect.gestionMatricula(36, baseCarrera, codEstudiante, codPeriodo, 'na').subscribe(translated => {
                resolve(translated)
            }));
        if (resPromedio.success)
            getPromedio = resPromedio.matricula[0].promTotal;

        return (getPromedio);
    }
    //FUNCION QUE MUESTRA EL DETALLE TOTAL DEL NUMERO DE MATRICULAS POR CARRERA
    async verTotalNumMatricula(baseCarrera, codPeriodo, cedEstudiante) {
        let lblDetalle = ''; let numPri = 0; let numSeg = 0; let numTer = 0; let vecNumMatricula = [];
        //OBTENER EL PROMEDIO EN BASE AL PERÍODO ANTERIOR
        const resNum = await new Promise<any>(resolve =>
            this.srvSelect.gestionMatricula(37, baseCarrera, cedEstudiante, codPeriodo, 'na').subscribe(translated => {
                resolve(translated)
            }));
        if (resNum.success) {
            for (let objNum of resNum.matricula) {
                lblDetalle += objNum.detalleNum + objNum.total + '; ';
                if (objNum.bytNumMat == 1)
                    numPri = objNum.total;
                if (objNum.bytNumMat == 2)
                    numSeg = objNum.total;
                if (objNum.bytNumMat == 3)
                    numTer = objNum.total;
            }
        }
        vecNumMatricula.push({ etiqueta: lblDetalle, primera: numPri, segunda: numSeg, tercera: numTer, banOpta: (numSeg > 0 || numTer > 0) ? 0 : 1 });
        return (vecNumMatricula);
    }
    //VER LOS AJUSTES DE UNA BECA (14 DADO LA BECA Y PERIODO) Y (15 SOLO SE DA LA BECA Y DETERMNIA EL ÚLTIMO AJUSTE)
    async getGeneralAjustesBeca(opc, idBeca, idPeriodo) {
        let vecAjusteBeca: Array<any> = [];
        const resAjuste = await new Promise<any>(resolve =>
            this.srvSelect.gestionBecas(opc, idBeca, idPeriodo, 'na').subscribe(translated => {
                resolve(translated)
            }));
        if (resAjuste.success)
            vecAjusteBeca = resAjuste.becas;
        else
            vecAjusteBeca.push({
                datFecha: '', intActualizar: '', intAdmite: '', intPersona: '', intTipoBeca: '', strCondiciones: '', strMailCargaReq: '',
                strMailEntregaReq: '', strMailObservaReq: '', strPeriodo: ''
            });
        return (vecAjusteBeca);
    }
    //DETERMINAR SI UNA PERSONA SE ENCUENTRA REGISTRADA EN LA CENTRALIZADA
    async genObtenerDataPersonaCentral(docPersona: string) {
        let vecPersona = [];

        const resCentral = await new Promise<any>(resolve => this.srvSelect.personaCentral2Documento(docPersona).subscribe(translated => { resolve(translated) }));
        if (resCentral.success) {
            vecPersona.push({
                estado: true, mensaje: '', idPersona: resCentral.listado[0].per_id, etnia: resCentral.listado[0].etn_nombre, sexo: resCentral.listado[0].sexo,
                nombres: resCentral.listado[0].per_nombres, apellidos: resCentral.listado[0].per_primerApellido + ' ' + resCentral.listado[0].per_segundoApellido,
                fono: resCentral.listado[0].per_telefonoCelular, nacionalidad: resCentral.listado[0].nac_nombre, celular: resCentral.listado[0].per_telefonoCelular,
                documento: docPersona, correo: resCentral.listado[0].per_email
            });
        }
        else
            vecPersona.push({ estado: false, mensaje: '' });
        return (vecPersona)
    }
    //DETERMINAR SI UNA PERSONA TIENE ACCION DE PERSONAL VIGENTE EN TTHH
    async genObtenerCargoTTHH(docPersona: string) {
        let auxPerfil = [];
        //OBTENER EL TOKEN PARA EL SERVICIO DE TTHH
        const resToken = await new Promise<any>(resolve => this.srvSelect.getAccesoTokenTTHH().subscribe(translated => { resolve(translated) }));
        
        //OBTENER EL CARGO DE LA PERSONA EN TTHH EN CASO DE TENER
        const resCargo = await new Promise<any>(resolve => this.srvSelect.getCargoDependenciaTTHH(docPersona, JSON.parse(resToken._body).data).subscribe(translated => { resolve(translated) }));
        if (resCargo.resultado) {
            if (resCargo.data.accionPersonal != undefined) {//DETERMINAR SI ES ADMINISTRATIVO
                auxPerfil.push({
                    estado: true, mensaje: '', tipo: resCargo.data.accionPersonal.apeRegimen, idTipo: 1, detTipo: 'Administrativo',
                    rol: resCargo.data.accionPersonal.apeCargo.replace('/A', '(A)').replace('/A', '(A)').replace('/A', '(A)'),
                    dependencia: resCargo.data.accionPersonal.apeDepedenciaEspecifica, nombres: resCargo.data.perNombres + ' ' + resCargo.data.perApellidos
                });
            }
            else {
                if (resCargo.data.contrato != undefined) {//DETERMINAR SI ES DOCENTE
                    auxPerfil.push({
                        estado: true, mensaje: '', tipo: resCargo.data.contrato.conRegimen, idTipo: 2, detTipo: 'Docente',
                        rol: resCargo.data.contrato.conCargo.replace('/A', '(A)').replace('/A', '(A)').replace('/A', '(A)'),
                        dependencia: resCargo.data.contrato.conDependenciaGeneral, nombres: resCargo.data.perNombres + ' ' + resCargo.data.perApellidos
                    });
                }
                else
                    auxPerfil.push({ estado: false, mensaje: '' });
            }
        } else
            auxPerfil.push({ estado: false, mensaje: '' });

        return (auxPerfil);
    }
}
